// Kostaja logo symbol. Single source of truth used in navbar, footer, corner mark.
import React from "react";

export const KostajaMark = ({ size = 28, className = "", testId = "kostaja-mark" }) => (
  <img
    src="/kostaja-symbol.png"
    alt="Kostaja"
    width={size}
    height={size}
    className={className}
    data-testid={testId}
    style={{ width: size, height: size, display: "inline-block" }}
    loading="eager"
    decoding="async"
  />
);

export default KostajaMark;
